module.exports = __webpack_public_path__ + "img/yunnan.df51c6ac.png";